import axios from "../index";


const getDataById = searched => {
    return axios.get(`search?searched=${searched}`)
}

export default {getDataById}